import React, { useEffect, useState } from "react";
import AdminShell from "@/components/AdminShell";
import { Link } from "react-router-dom";
import { getToken } from "@/lib/auth";

export default function AdminDashboard() {
  const [overview, setOverview] = useState(null);

  useEffect(() => {
    const token = getToken();
    fetch("/api/admin/overview", { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => { if (data) setOverview(data); })
      .catch(() => {});
  }, []);

  return (
    <AdminShell>
      <div className="p-6 md:p-10 text-white">
        <div className="text-[11px] tracking-[0.28em] uppercase text-[#D4AF37] mb-2">Admin</div>
        <h1 className="font-display text-3xl mb-8">Dashboard</h1>

        <div className="grid md:grid-cols-4 gap-6 mb-10">
          <Card label="Total Users"    value={overview?.total_users} />
          <Card label="Pending Media"  value={overview?.pending_media} />
          <Card label="Open Reports"   value={overview?.open_reports} />
          <Card label="System Health"  value={overview?.system_health ? overview.system_health.toUpperCase() : "--"} highlight />
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-10">
          <Card label="Active Users"   value={overview?.active_users} />
          <Card label="Onboarded"      value={overview?.onboarded_users} />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {[
            { to: "/admin/users",                label: "Users",                desc: "Manage accounts and roles" },
            { to: "/admin/metrics",              label: "Metrics",              desc: "Platform analytics" },
            { to: "/admin/intelligence",         label: "Intelligence",         desc: "Funnel · drop-offs · recovery" },
            { to: "/admin/heatmap",              label: "Heatmap",              desc: "User activity map" },
            { to: "/admin/messages",             label: "Messages",             desc: "Admin messaging" },
            { to: "/admin/private-applications", label: "Private Applications", desc: "Membership review" },
          ].map(({ to, label, desc }) => (
            <Link
              key={to}
              to={to}
              className="glass p-6 rounded-2xl border border-white/10 hover:border-[rgba(212,175,55,0.3)] transition-all group"
            >
              <div className="font-semibold text-white group-hover:text-[#D4AF37] transition-colors mb-1">{label}</div>
              <div className="text-sm text-white/50">{desc}</div>
            </Link>
          ))}
        </div>
      </div>
    </AdminShell>
  );
}

function Card({ label, value, highlight }) {
  return (
    <div className="glass p-6 rounded-xl border border-white/10">
      <div className="text-white/50 text-sm">{label}</div>
      <div className={`text-2xl font-display mt-2 ${highlight ? "text-emerald-400" : ""}`}>
        {value !== null && value !== undefined ? value : "--"}
      </div>
    </div>
  );
}
